<startup-loading></startup-loading>
<startup-error></startup-error>
<app-intro *ngIf="this.appIntroService.visible()"></app-intro>

<router-outlet></router-outlet>
